import { zIndex as mainZIndex } from "../../../../settings";
export var breakpointValue = "large";
export var hugeBreakpointValue = "huge";
export var zIndex = {
  mainSticky: 5 + mainZIndex.PageHeaderOrgMain,
  headerBottomBar: 4 + mainZIndex.PageHeaderOrgMain,
  dropdown: mainZIndex.PageHeaderOrgMain,
  bar: 4 + mainZIndex.PageHeaderOrgMain,
  accountDropdown: 3 + mainZIndex.PageHeaderOrgMain,
  main: 2 + mainZIndex.PageHeaderOrgMain,
  navigation: 1 + mainZIndex.PageHeaderOrgMain
};
export var barHeightSpaceOnMobile = 5;
export var barHeightSpaceOnDesktop = 4;
export var mainHeightSpaceOnMobile = 8;
export var mainHeightSpaceOnDesktop = 9;
export var navigationBackgroundOnMobile = "backgroundLight";
export var navigationBackgroundOnDarkMode = "backgroundBlack";